import React, { useRef } from "react";
import { ToggleButton } from "@components/atoms/ToggleButton";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function PlanComparisionMobile({
  heading,
  categories,
  planCost,
  ctaButtons,
  isdiffHeading,
  note,
}) {
  const planComparisionDOM = useRef(null);

  const Plans = ({ plans, ...props }) => {
    return (
      <div {...props}>
        {plans.map((plan, index) => (
          <span className="fw-600 header" key={index}>
            {plan}
            <style jsx>{`
            @media (max-width: ${viewport.mobile.sm}) {
             .header{
               min-width: 100px !important;
              }
            `}</style>
          </span>
        ))}
      </div>
    );
  };

  const SideSection = ({ data, ...props }) => {
    return (
      <div {...props}>
        {data.map((item, index) => (
          <span
            className={`${
              index == 0 ? "fw-600 header md:mb-3" : "sub-header"
            } ${item === "." ? "none" : ""} ${
              index == data.length - 1 && data[0] === "Support"
                ? "md:mb-10 md:pb-5"
                : ""
            }`}
            key={index}
            dangerouslySetInnerHTML={{ __html: item }}
          />
        ))}
      </div>
    );
  };

  const List = ({ data }) => {
    const FeatureAvailabilityList = ({ data }) => {
      if (data === "yes") {
        return <li></li>;
      } else if (data === "no") {
        return <li className="none unavailable"></li>;
      } else {
        return (
          <>
            <p
              className="lg:ml-auto"
              dangerouslySetInnerHTML={{ __html: data }}
            />
          </>
        );
      }
    };

    return data.map((item, index) => (
      <ul
        className={`ticked-bulletin list-item ${
          index == data.length - 1 ? "md:mb-2" : ""
        }`}
        key={index}
      >
        {item.details.map((item, index) => (
          <FeatureAvailabilityList data={item} key={index} />
        ))}
        <style jsx>{`
            @media (max-width: ${viewport.mobile.sm}) {
              .list-item :global(p),.list-item :global(li){
                  min-width: 100px !important;
                }
        `}</style>
      </ul>
    ));
  };
  const Category = ({ title, features, index }) => {
    const getheadingAndSubHeading = () => {
      const subHeading = [];
      features.forEach((item) => {
        subHeading.push(item.heading);
      });
      return [title, ...subHeading];
    };

    return (
      <>
        <SideSection
          data={getheadingAndSubHeading()}
          className={`${
            index == 0
              ? "md:fx--w md:pb-0 p-block"
              : "md:fx--w md:mt-2 md:pb-0 md:mb-0 p-block"
          }`}
        />
        <Plans
          plans={heading.plans}
          className={`${
            index === 0
              ? "list-item md:pb-2 md:pt-2 ticked-bulletin"
              : "list-item md:pb-2.5 md:pt-4 ticked-bulletin"
          } ${index === 2 ? "md:pb-2" : ""}`}
        />
        <List data={features} />
      </>
    );
  };

  const ToggleButtonContainer = ({ plans }) => (
    <div className="billing-type-wrap md:pb-10 md:pt-5 md:text-center">
      <span id="monthly-billing-span-cta" className="monthly-billing-span">
        {plans && plans[0]}
      </span>
      <div className="togg-btn-wrap">
        <ToggleButton />
      </div>
      <span id="annual-billing-span-cta" className="annual-billing-span">
        {plans && plans[1]}
      </span>
      <figure
        className="abs--img monthly-billing-span"
        id="dis-img-toggle-mobile-cta"
      >
        <svg
          width="106"
          height="24"
          viewBox="0 0 106 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 14C5.477 14 1 18.477 1 24"
            stroke="#068F86"
            strokeWidth="1.25"
          />
          <path
            d="M21.818 9.909V17h-.742c-.177 0-.29-.086-.336-.259l-.098-.763c-.308.34-.653.616-1.036.826a2.74 2.74 0 0 1-1.316.308c-.387 0-.73-.063-1.029-.189a2.077 2.077 0 0 1-.742-.546 2.345 2.345 0 0 1-.455-.847 3.865 3.865 0 0 1-.147-1.099V9.909h1.246v4.522c0 .537.121.952.364 1.246.247.294.623.441 1.127.441.369 0 .712-.086 1.029-.259.322-.177.618-.42.889-.728V9.909h1.246zm3.299 5.383c.228.308.478.525.749.651.27.126.574.189.91.189.662 0 1.171-.236 1.526-.707.354-.471.532-1.143.532-2.016 0-.462-.042-.859-.126-1.19a2.246 2.246 0 0 0-.35-.812 1.366 1.366 0 0 0-.567-.469 1.886 1.886 0 0 0-.763-.147c-.406 0-.763.093-1.071.28a3.1 3.1 0 0 0-.84.791v3.43zm-.063-4.284a3.673 3.673 0 0 1 1.036-.889 2.66 2.66 0 0 1 1.344-.336c.41 0 .781.08 1.113.238.331.154.613.385.847.693.233.303.413.681.539 1.134.126.453.189.973.189 1.561 0 .523-.07 1.01-.21 1.463-.14.448-.343.838-.61 1.169a2.855 2.855 0 0 1-.965.777c-.378.187-.805.28-1.281.28-.434 0-.808-.072-1.12-.217a2.685 2.685 0 0 1-.82-.616v3.136h-1.252V9.909h.749c.177 0 .287.086.329.259l.112.84zm12.556 6.104c-.56 0-.991-.156-1.295-.469-.298-.313-.448-.763-.448-1.351v-4.34h-.854a.289.289 0 0 1-.189-.063c-.051-.047-.077-.117-.077-.21v-.497l1.162-.147.287-2.191a.297.297 0 0 1 .091-.168.28.28 0 0 1 .196-.07h.63v2.443h2.051v.903h-2.05v4.256c0 .299.072.52.216.665a.758.758 0 0 0 .56.217 1.02 1.02 0 0 0 .588-.168c.07-.042.129-.08.175-.112.052-.037.096-.056.133-.056.066 0 .124.04.175.119l.364.595c-.214.2-.473.36-.777.476a2.687 2.687 0 0 1-.938.168zm5.859-7.315c.518 0 .985.086 1.4.259.415.173.77.418 1.064.735.294.317.518.702.672 1.155.159.448.238.95.238 1.505 0 .56-.08 1.064-.238 1.512a3.19 3.19 0 0 1-.672 1.148 3.001 3.001 0 0 1-1.064.735 3.704 3.704 0 0 1-1.4.252c-.523 0-.994-.084-1.414-.252a3.001 3.001 0 0 1-1.064-.735c-.294-.317-.52-.7-.68-1.148a4.634 4.634 0 0 1-.23-1.512c0-.555.077-1.057.23-1.505.16-.453.386-.838.68-1.155a3.001 3.001 0 0 1 1.064-.735c.42-.173.891-.259 1.414-.259zm0 6.328c.7 0 1.223-.233 1.568-.7.345-.471.518-1.127.518-1.967 0-.845-.173-1.503-.518-1.974-.345-.471-.868-.707-1.568-.707-.355 0-.665.06-.931.182-.261.121-.48.296-.658.525a2.41 2.41 0 0 0-.392.847 4.598 4.598 0 0 0-.126 1.127c0 .84.173 1.496.518 1.967.35.467.88.7 1.589.7zm10.223-5.369a6.92 6.92 0 0 1 1.442-.168c.523 0 .985.077 1.386.231.402.154.735.366 1.001.637.27.27.474.59.61.959.14.369.21.77.21 1.204 0 .532-.094 1.013-.28 1.442a3.238 3.238 0 0 1-1.905 1.806 4.041 4.041 0 0 1-1.42.245 3.86 3.86 0 0 1-.848-.091 4.273 4.273 0 0 1-1.414-.567 3.762 3.762 0 0 1-.532-.399l.385-.532a.384.384 0 0 1 .33-.182c.093 0 .198.037.314.112.117.07.26.15.427.238.168.089.364.17.588.245.229.07.5.105.812.105.35 0 .665-.056.945-.168.28-.112.52-.27.721-.476.2-.21.355-.46.462-.749.108-.29.161-.614.161-.973 0-.313-.046-.595-.14-.847a1.612 1.612 0 0 0-.413-.644 1.86 1.86 0 0 0-.686-.413 2.88 2.88 0 0 0-.966-.147 5.249 5.249 0 0 0-1.624.266l-.784-.231.805-4.69h4.753v.546a.611.611 0 0 1-.168.441c-.107.112-.294.168-.56.168h-3.15l-.462 2.632zm9.717 5.362c.327 0 .619-.044.875-.133.262-.093.481-.222.658-.385.182-.168.32-.366.413-.595.098-.233.147-.49.147-.77 0-.345-.058-.64-.175-.882a1.577 1.577 0 0 0-.462-.602 1.827 1.827 0 0 0-.665-.336 2.769 2.769 0 0 0-.79-.112c-.276 0-.54.037-.792.112-.252.07-.476.182-.672.336a1.673 1.673 0 0 0-.462.602c-.112.243-.168.537-.168.882 0 .28.047.537.14.77.098.229.236.427.413.595.182.163.402.292.658.385.262.089.556.133.882.133zm0-8.295c-.298 0-.562.044-.79.133-.225.089-.414.21-.568.364-.149.154-.263.334-.343.539a1.91 1.91 0 0 0-.112.658c0 .229.033.45.098.665.066.215.17.406.315.574.145.163.332.296.56.399.234.098.514.147.84.147.327 0 .605-.049.833-.147a1.61 1.61 0 0 0 .567-.399c.145-.168.25-.36.315-.574.066-.215.098-.436.098-.665 0-.233-.04-.453-.119-.658a1.458 1.458 0 0 0-.343-.539 1.564 1.564 0 0 0-.567-.364 2.122 2.122 0 0 0-.784-.133zm1.435 3.948c.626.177 1.106.474 1.442.889.336.415.504.947.504 1.596 0 .439-.084.835-.252 1.19-.163.35-.394.649-.693.896a3.146 3.146 0 0 1-1.064.574c-.415.13-.872.196-1.372.196-.499 0-.956-.065-1.372-.196a3.224 3.224 0 0 1-1.07-.574 2.549 2.549 0 0 1-.694-.896 2.81 2.81 0 0 1-.245-1.19c0-.649.168-1.18.504-1.596.336-.415.817-.712 1.442-.889-.527-.196-.926-.488-1.197-.875-.266-.392-.399-.859-.399-1.4a2.479 2.479 0 0 1 .833-1.876c.266-.238.584-.425.952-.56a3.634 3.634 0 0 1 1.246-.203c.453 0 .866.068 1.24.203.373.135.692.322.958.56a2.48 2.48 0 0 1 .833 1.876c0 .541-.135 1.008-.406 1.4-.266.387-.662.679-1.19.875zm7.75-2.38c0 .392-.06.744-.181 1.057-.122.308-.285.57-.49.784a2.16 2.16 0 0 1-1.554.651c-.313 0-.605-.056-.876-.168a2.051 2.051 0 0 1-.706-.483 2.326 2.326 0 0 1-.463-.784 3.12 3.12 0 0 1-.168-1.057c0-.401.056-.758.168-1.071.112-.313.267-.576.463-.791.2-.215.436-.378.706-.49.271-.112.563-.168.876-.168.317 0 .61.056.882.168.27.112.506.275.706.49.201.215.358.478.47.791.111.313.167.67.167 1.071zm-.965 0c0-.308-.033-.57-.099-.784a1.433 1.433 0 0 0-.273-.525.956.956 0 0 0-.398-.301 1.325 1.325 0 0 0-.49-.091c-.173 0-.334.03-.484.091a.965.965 0 0 0-.392.301c-.111.135-.2.31-.265.525a2.718 2.718 0 0 0-.099.784c0 .303.033.562.099.777.065.21.154.383.266.518.112.13.242.226.391.287.15.056.31.084.483.084s.337-.028.49-.084c.154-.06.287-.156.4-.287.116-.135.207-.308.273-.518.065-.215.097-.474.097-.777zm4.514-2.212a.802.802 0 0 1 .162-.147.473.473 0 0 1 .258-.063h.903l-7.335 9.828a.486.486 0 0 1-.162.147.473.473 0 0 1-.237.056h-.918l7.33-9.821zm2.002 7.455c0 .392-.06.742-.181 1.05-.122.308-.285.57-.49.784a2.16 2.16 0 0 1-1.554.651c-.318 0-.612-.056-.883-.168a2.069 2.069 0 0 1-.7-.483 2.326 2.326 0 0 1-.462-.784 3.06 3.06 0 0 1-.168-1.05c0-.401.056-.758.169-1.071.111-.317.265-.583.462-.798.2-.215.434-.378.7-.49.27-.112.564-.168.882-.168.312 0 .604.056.874.168.276.112.511.275.707.49.201.215.358.48.47.798.116.313.174.67.174 1.071zm-.965 0c0-.308-.033-.57-.099-.784a1.43 1.43 0 0 0-.273-.532.98.98 0 0 0-.399-.294 1.324 1.324 0 0 0-.49-.091c-.172 0-.335.03-.49.091a.99.99 0 0 0-.392.294c-.112.135-.2.313-.266.532-.06.215-.09.476-.09.784 0 .303.03.56.09.77.066.21.154.383.266.518.112.13.243.226.392.287.154.056.318.084.49.084.173 0 .337-.028.49-.084.154-.06.287-.156.4-.287.116-.135.207-.308.273-.518a2.62 2.62 0 0 0 .098-.77zm9.283-4.837c.518 0 .985.086 1.4.259.415.173.77.418 1.064.735.294.317.518.702.672 1.155.159.448.238.95.238 1.505 0 .56-.08 1.064-.238 1.512a3.19 3.19 0 0 1-.672 1.148 3.001 3.001 0 0 1-1.064.735 3.704 3.704 0 0 1-1.4.252c-.523 0-.994-.084-1.414-.252a3.001 3.001 0 0 1-1.064-.735c-.294-.317-.52-.7-.679-1.148a4.634 4.634 0 0 1-.23-1.512c0-.555.076-1.057.23-1.505.159-.453.385-.838.68-1.155a3.001 3.001 0 0 1 1.063-.735c.42-.173.891-.259 1.414-.259zm0 6.328c.7 0 1.223-.233 1.568-.7.345-.471.518-1.127.518-1.967 0-.845-.173-1.503-.518-1.974-.345-.471-.868-.707-1.568-.707-.355 0-.665.06-.93.182-.262.121-.482.296-.659.525a2.41 2.41 0 0 0-.392.847 4.598 4.598 0 0 0-.126 1.127c0 .84.173 1.496.518 1.967.35.467.88.7 1.59.7zM91.8 17v-6.027l-.784-.091a.693.693 0 0 1-.245-.105.269.269 0 0 1-.09-.217v-.511h1.12v-.581c0-.406.055-.765.167-1.078.117-.317.28-.583.49-.798.215-.22.471-.385.77-.497a2.854 2.854 0 0 1 1.008-.168c.317 0 .61.047.875.14l-.028.63c-.01.112-.072.173-.189.182-.112.01-.264.014-.455.014-.215 0-.41.028-.588.084-.173.051-.322.14-.448.266a1.264 1.264 0 0 0-.294.504c-.065.205-.098.46-.098.763v.539h3.2v-.763c0-.406.055-.765.167-1.078.117-.317.28-.583.49-.798.215-.22.471-.385.77-.497a2.854 2.854 0 0 1 1.008-.168c.313 0 .604.047.875.14l-.028.623c-.01.112-.072.173-.189.182-.112.01-.264.014-.455.014-.215 0-.41.028-.588.084a1.107 1.107 0 0 0-.448.273 1.268 1.268 0 0 0-.294.497c-.065.205-.098.46-.098.763v.728h2.044v.903h-2.002V17H96.21v-6.048h-3.157V17H91.8zm13.021-7.413-.308.525-1.211-.7a2.286 2.286 0 0 1-.224-.154.776.776 0 0 1-.175-.196c.074.154.112.324.112.511v1.386h-.616V9.58c0-.093.004-.18.014-.259a.82.82 0 0 1 .077-.231 1.271 1.271 0 0 1-.378.322l-1.204.693-.308-.525 1.204-.7c.177-.107.354-.163.532-.168a1.73 1.73 0 0 1-.273-.049 1.183 1.183 0 0 1-.259-.126l-1.211-.707.308-.525 1.211.7c.084.051.158.105.224.161a.959.959 0 0 1 .175.203 1.243 1.243 0 0 1-.112-.525V6.458h.616v1.379c0 .093-.007.182-.021.266a.72.72 0 0 1-.07.231c.051-.065.107-.124.168-.175.06-.051.13-.103.21-.154l1.204-.693.308.525-1.204.7c-.08.051-.159.091-.238.119-.08.028-.164.047-.252.056.088.01.172.028.252.056a.93.93 0 0 1 .238.112l1.211.707z"
            fill="#068F86"
          />
        </svg>
      </figure>
      <style jsx>{`
        #dis-img-toggle-mobile-cta {
          position: relative;
          top: -62px;
          top: -50px;
          display: inline-block;
          opacity: 0;
        }
        #dis-img-toggle-mobile-cta.abs--img {
          opacity: 0;
        }
        #dis-img-toggle-mobile-cta.active {
          opacity: 1;
        }
        #dis-img-toggle-mobile-cta {
          left: 80px;
          left: 76px;
        }
        .togg-btn-wrap {
          display: inline-block;
          vertical-align: middle;
          margin: 0 12px 0 16px;
        }
        .billing-type-wrap span {
          vertical-align: middle;
          display: inline-block;
          text-align: left;
          width: calc(50% - 50px);
          font-size: ${font.size.sm[3]};
        }
        .annual-billing-span.active,
        .monthly-billing-span.active {
          font-weight: ${font.weight.bold};
          color: ${colors.primitive.black[100]};
        }
        .billing-type-wrap span:first-child {
          text-align: right;
        }
        .abs--img {
          top: 90px;
          left: 84px;
          position: absolute;
          transition-property: opacity;
          transition-duration: 0.5s;
        }
        #dis-img-toggle {
          position: relative;
          left: -30%;
          top: -5px;
          display: inline-block;
          opacity: 0;
        }
        #annual-dis-img-cta.abs--img,
        #annual-dis-img.abs--img,
        #annual-pro-dis-img.abs--img,
        #dis-img-toggle.abs--img,
        #monthly-dis-img-cta.abs--img,
        #monthly-dis-img.abs--img {
          opacity: 0;
        }
        #annual-dis-img-cta.active,
        #annual-dis-img.active,
        #annual-pro-dis-img.active,
        #dis-img-toggle.active,
        #monthly-dis-img-cta.active,
        #monthly-dis-img.active {
          opacity: 1;
        }
        .billing-toggle {
          margin-left: 38%;
          margin-right: -25px;
        }
        @media (max-width: ${viewport.tablet.sm}) {
          .abs--img {
            left: 66px;
          }
          #dis-img-toggle {
            left: 20%;
          }
          .billing-toggle #dis-img-toggle {
            left: -30%;
            top: -5px;
          }
        }
      `}</style>
    </div>
  );

  const PlanCost = () => {
    const Cost = ({ data }) =>
      data.map((cost, index) => <span key={index}>{cost}</span>);

    return (
      planCost && (
        <ul className="pr-card pr-card-toggle pricing-toggle-mobile-cta lg:mt-1 list-item md:mt-1.5 md:mb-1">
          {planCost?.price?.map((item, index) => (
            <li key={index}>
              <p className="plan-price fw-700 text-center">
                <strong
                  className={`${item.length > 1 && "highlight price-wrapper"}`}
                >
                  $<Cost data={item} />
                </strong>{" "}
                <span className="plan-duration-wrap">
                  {planCost.durationMobile}
                </span>
              </p>
            </li>
          ))}
        </ul>
      )
    );
  };

  const CTAButtons = () => {
    const appMode = process.env.APP_MODE;
    const Buttons = ({ data }) =>
      data?.map((button, index) => (
        <p className="md:-mt-5 md:pt-4" key={index}>
          <a
            href={button?.href?.[appMode] || button?.href}
            className={`${button.mobileVariant}`}
            id={button.id}
          >
            {button.content}
          </a>
        </p>
      ));
    return (
      <ul className="list-item">
        <Buttons data={ctaButtons?.buttons} />
      </ul>
    );
  };

  const Accordion = () => {
    const showTogglePlans = (e) => {
      e.target.classList.toggle("active");
      e.target.nextElementSibling.classList.toggle("active");
      planComparisionDOM.current.setAttribute("style", "display: block");

      setTimeout(function () {
        location.href = "#mobile";
      }, 25);
      setTimeout(function () {
        document.getElementById("swipeimage").style.display = "none";
      }, 1500);
    };
    const hideTogglePlans = (e) => {
      e.target.classList.toggle("active");
      e.target.previousElementSibling.classList.toggle("active");
      planComparisionDOM.current.removeAttribute("style", "display: block");
    };

    return (
      <section
        className="bg-white container faq-section p-block md:-mt-5"
        id="seeplan-toggle"
      >
        <div className="faq w-100">
          <label
            className="faq-ques active isdiffHeading"
            id="hide"
            htmlFor="chckT"
            onClick={showTogglePlans}
          >
            {isdiffHeading ? "See payment features" : "See plans comparison"}
          </label>
          <label
            className="faq-ques"
            id="show"
            htmlFor="chckT"
            onClick={hideTogglePlans}
          >
            {isdiffHeading ? "Hide payment features" : "Hide plans comparison"}
          </label>
        </div>
        <style jsx>{`
          label.faq-ques {
            display: none !important;
            padding-right: 30px;
          }
          label.faq-ques::after {
            border-style: solid;
            border-width: 2px 2px 0 0;
            content: "";
            height: 12px;
            width: 12px;
            position: relative;
            top: 5px;
            right: unset;
            text-align: center;
            transition: all 0.35s;
            color: ${colors.primitive.violet[100]};
            transform: rotate(135deg);
            background: none;
          }
        `}</style>
      </section>
    );
  };

  return (
    <>
      <section
        className="pricing-wrap container pr-features md:-mt-5 md:ml-0 md:mr-0 mobile-view lg:d-none"
        id="planComparisionContainerMobile"
        ref={planComparisionDOM}
      >
        <img
          id="swipeimage"
          src="https://assets.setmore.com/website/v2/images/icons/swipe-to-compare.png"
          alt="Swipe to compare icon"
          loading="lazy"
        />
        <div className="card--default has-three-col has-gutter-md mx-auto lg:-mt-10 lg:pb-10">
          {categories.map((category, index) => (
            <Category
              title={category.title}
              features={category.list}
              key={index}
              index={index}
            />
          ))}
          <PlanCost />
          <CTAButtons />
        </div>
        {note && (
          <p
            className="lg:mt-5 md:mt-2 lg:px-2 md:px-4 text-left text-grey-800 text-xxs "
            dangerouslySetInnerHTML={{ __html: note }}
          />
        )}
        {planCost?.plansMobile && (
          <ToggleButtonContainer plans={planCost.plansMobile} />
        )}
      </section>
      <Accordion />
    </>
  );
}
